/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown>, currency: NonNullable<unknown>, "pack title": NonNullable<unknown> }} Dialog_Purchase_Confirm_DescriptionInputs */

const en_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Do you want to spend ${i?.number} ${i?.currency}s to purchase ${i?.["pack title"]}?`)
};

const ar_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هل ترغب في إنفاق ${i?.number} ${i?.currency} لشراء ${i?.["pack title"]}؟`)
};

const de_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchtest du ${i?.number} ${i?.currency} ausgeben, um das ${i?.["pack title"]} zu kaufen?`)
};

const es_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Deseas gastar ${i?.number} ${i?.currency} para comprar el ${i?.["pack title"]}?`)
};

const fr_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous acheter ${i?.["pack title"]} pour ${i?.number} ${i?.currency} ?`)
};

const it_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuoi spendere ${i?.number} ${i?.currency} per acquistare ${i?.["pack title"]}?`)
};

const ja_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.currency}を${i?.number}を使って、${i?.["pack title"]}を購入しますか？`)
};

const ko_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} ${i?.currency}을(를) 사용해 ${i?.["pack title"]}를 구매하시겠어요?`)
};

const pt_br_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deseja gastar ${i?.number} ${i?.currency} para adquirir ${i?.["pack title"]}?`)
};

const ru_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Хотите потратить ${i?.number} ${i?.currency}, чтобы купить ${i?.["pack title"]}?`)
};

const th_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`คุณต้องการใช้ ${i?.number} ${i?.currency} เพื่อซื้อ ${i?.["pack title"]} หรือไม่?`)
};

const tr_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} ${i?.currency} harcayarak ${i?.["pack title"]} satın almak istiyor musun?`)
};

const zh_cn_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`确认花费 ${i?.number} 个 ${i?.currency} 购买“${i?.["pack title"]}”吗？`)
};

const zh_tw_dialog_purchase_confirm_description = /** @type {(inputs: Dialog_Purchase_Confirm_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`確認要花費 ${i?.number} 個${i?.currency}來購買${i?.["pack title"]}嗎？`)
};

/**
* | output |
* | --- |
* | "Do you want to spend {number} {currency}s to purchase {pack title}?" |
*
* @param {Dialog_Purchase_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_purchase_confirm_description = /** @type {((inputs: Dialog_Purchase_Confirm_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Purchase_Confirm_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_purchase_confirm_description(inputs)
	if (locale === "ar") return ar_dialog_purchase_confirm_description(inputs)
	if (locale === "de") return de_dialog_purchase_confirm_description(inputs)
	if (locale === "es") return es_dialog_purchase_confirm_description(inputs)
	if (locale === "fr") return fr_dialog_purchase_confirm_description(inputs)
	if (locale === "it") return it_dialog_purchase_confirm_description(inputs)
	if (locale === "ja") return ja_dialog_purchase_confirm_description(inputs)
	if (locale === "ko") return ko_dialog_purchase_confirm_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_purchase_confirm_description(inputs)
	if (locale === "ru") return ru_dialog_purchase_confirm_description(inputs)
	if (locale === "th") return th_dialog_purchase_confirm_description(inputs)
	if (locale === "tr") return tr_dialog_purchase_confirm_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_purchase_confirm_description(inputs)
	return zh_tw_dialog_purchase_confirm_description(inputs)
});